/**
 * lightbox
 */
import config from './config'
import cpSite from './cpSite'
import { loadScript } from './loadScript'
import { loadCSS } from './loadCSS'
import { waitModuleReady } from './waitModuleReady'

let init = false

const lightbox = {
  depend: ['jquery'],
  state: {
    lib: config.DEVMODE ? ['js/lightbox/jquery.magnific-popup.js', 'js/lightbox/magnific-popup.css'] : [config.THEME + 'js/lightbox/jquery.magnific-popup.js', config.THEME + 'js/lightbox/magnific-popup.css'],
    isActive: false
  },
  activate: function () {
    if (config.DEVMODE) {
      console.log('active: lightbox')
    }
    // Не проводить повторную инициализацию
    if (init) return

    // Убеждаемся, что объекты существуют
    // const querySelector = 'a[rel="lightbox"], a:has(> img.lb)' // либо <a rel="lightbox"... либо <a><img class="lb"...
    // a:has(> img.lb) не поддерживается в IE11.
    const querySelector = 'a[rel="lightbox"],img.lb'
    const links = document.querySelectorAll(querySelector)
    // Если объектов нет, то ничего не делать
    if (!links.length) {
      if (config.DEVMODE) {
        console.log('lightbox: no elements')
      }
      return
    }

    // Инициализация
    this.initialize(this)
    // Ожидание готовности новых скриптов
    waitModuleReady(() => window?.jQuery?.magnificPopup, () => { this.find(querySelector) }, 100)
  },
  initialize () {
    cpSite.module.jquery.activate()
    loadScript(this.state.lib[0])
    loadCSS(this.state.lib[1])
    init = true
    this.state.isActive = true
  },
  find (param) {
    const $ = window.jQuery
    $(param).magnificPopup({
      /* items: {
              //src: $('<div class="white-popup">Dynamically created popup</div>'),
              //src: '#more-popup',
              //src: 'https://cryptopro.ru/sites/default/files/products/ngate/overview/ngate_cluster.jpg',
              //type: 'inline'
          }, */
      callbacks: {
        elementParse: function (item) {
          // Function will fire for each target element
          // "item.el" is a target DOM element (if present)
          // "item.src" is a source that you may modify
          item.src = item.el.parent()?.attr('href') ?? item.el?.attr('href') ?? item.el.attr('src')
          // todo: как прописать title?
          // item.title = item.el.parent().attr('title') ?? item.el?.attr('title') ?? item.el.attr('alt')
          item.type = 'image'
        }
      }
    })
  }
}
export default lightbox
